<template>
  <div>
    <section class="section">
      <div class="container">
        <h1 class="title">
          About
        </h1>
        <section>
          <p class="block">
            BeatCaps is an organization working to add multi-sensual experiences
            to streaming music. We are working closely with the Canadian
            Cultural Society of the Deaf. We've worked closely with large video
            streaming companies in the past and hope to put our patented
            technology to the test.
          </p>
          <p class="block">
            We've been incredibly inspired by a form of soundless music called
            <a
              href="https://www.youtube.com/watch?v=FLazgI_phNQ&list=UUBsu7Zj5VCylr4m7I_CWM7g&index=32&t=117s"
            >
              signed music
            </a>
            , created in the Deaf community. One of our goals is to bring
            multi-sensual experiences to audible music so it can enjoyed by
            everyone.
          </p>
          <p class="block">
            Our team is a group of musician-developers who want to share their
            love for audible music with Deaf people. We use AI to create
            soundless music experiences that translate back and forth between
            hearing and Deaf individuals, such that Deaf musicians can be heard
            and hearing musicians can be experienced.
          </p>
          <p class="block">
            People want more than accessible solutions; they want memorable
            experiences. The most important part of music to us is not the
            rhythms or the lyrics or the melodies, but the feelings that you get
            from experiencing it. Many music visualization tools exist, but
            only to look cool, displaying pitch through spectrum analysis.
            You can't feel the music enough to do a dance or a spin class.
          </p>
          <p class="block">
            We hate how stale streaming technology has become. Most of R&amp;D
            budgets actually fund content licenses. Most platforms have good
            exclusive content. Platforms that want to monopolize must innovate
            on the experience. We're here to help.
          </p>
        </section>
        <section>
          <h2 class="is-size-3">
            Our Team
          </h2>
          <div class="tile is-ancestor is-parent is-12 has-text-centered">
            <div class="tile is-child notification is-primary">
              <figure class="image is-128x128 is-inline-block">
                <img
                  class="is-rounded"
                  src="img/kemal-team.jpg"
                  aria-labelledby="kemal-name"
                >
              </figure>
              <div>
                <p
                  id="kemal-name"
                  class="title"
                >
                  Kemal Ahmed
                </p>
                <p class="subtitle">
                  Lead Developer / CEO
                </p>
              </div>
            </div>
            <div class="tile is-child notification is-warning">
              <figure class="image is-128x128 is-inline-block">
                <img
                  class="is-rounded"
                  src="img/beth-team.jpg"
                  aria-labelledby="beth-name"
                >
              </figure>
              <div>
                <p
                  id="beth-name"
                  class="title"
                >
                  Bethany Mercer
                </p>
                <p class="subtitle">
                  Business Analyst
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
    <section class="section">
      <!-- <h2 class="title">Pricing</h2> -->
      <div class="container">
        <h2 class="title">
          Pricing
        </h2>
        <!-- <h2 class="title has-text-centered">Pricing</h2> -->
      </div>

      <div class="container">
        <nav class="level">
          <div class="level-item has-text-centered">
            <div>
              <p class="subtitle">
                Creator
              </p>
              <p class="heading">
                Use our hosted cloud service
              </p>
              <p class="title">
                Coming Soon
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="subtitle">
                Enterprise
              </p>
              <p class="heading">
                We build it into your cloud
              </p>
              <a
                class="title"
                href="mailto:info@beatcaps.io"
              >Contact Us</a>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="subtitle">
                License
              </p>
              <p class="heading">
                License our patent
              </p>
              <a
                class="title"
                href="mailto:info@beatcaps.io"
              >Contact Us</a>
            </div>
          </div>
        </nav>
        <a
          href="mailto:info@beatcaps.io"
        >Let us know if you'd like to work with our grant writer</a>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  props: {},
  data () {
    return {}
    // • █
  },
  computed: {},
  watch: {},
  created () {
    this.$emit('theme', 'light')
  }
}
</script>
<style>
.section-left {
  text-align: left;
  margin-top: 1rem;
}
</style>
